import { SxProps, Theme } from "@mui/material";
import { AdjustmentTypeEnum } from "helpers/types";

export const strategyStyles = {
  adjustmentDataGrid: {
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
      overflow: "visible",
      textOverflow: "unset",
      alignItems: "center",
      py: 1,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: 1.2,
    },
    "& .MuiDataGrid-columnHeader": {
      height: "unset !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      maxHeight: "none !important",
    },
  } as SxProps<Theme>,
};

const ADJUSTMENT_TYPE_COLORS: Record<AdjustmentTypeEnum, string> = {
  [AdjustmentTypeEnum.INCEPTION]: "warning.main",
  [AdjustmentTypeEnum.BUY]: "success.main",
  [AdjustmentTypeEnum.SELL]: "error.main",
  [AdjustmentTypeEnum.REMOVED]: "grey.500",
};

export const getAdjustmentTypeColor = (
  adjustmentType: AdjustmentTypeEnum,
): string => ADJUSTMENT_TYPE_COLORS[adjustmentType] ?? "text.primary";
